
import {
  createModule,
  
} from 'yoshi-flow-bm-runtime';
const createBILogger = undefined;
import type { ModuleLite } from 'yoshi-flow-bm-runtime/common';

createModule({
  module: {
    module: {"moduleId":"crm-financial-widgets","config":{"moduleConfigurationId":"INVOICES","appDefId":"13ee94c1-b635-8505-3391-97919052c16f","isCoreService":false,"routeNamespace":"crm-financial-widgets","translations":{"enabled":true,"suspense":true},"sentry":{"DSN":"https://da4a8e3d62b14102bf44b208c83b87c6@sentry.wixpress.com/1048","id":"da4a8e3d62b14102bf44b208c83b87c6","projectName":"crm-financial-widgets","teamName":"crm-financial"},"experiments":{"scopes":["business-manager","my-account"]},"bi":"@wix/bi-logger-dash","moduleId":"crm-financial-widgets","topology":{"staticsUrl":{"artifactId":"com.wixpress.crm.crm-financial-widgets"}},"moduleBundleName":"module"},"fedopsPath":"/home/builduser/work/8dadf0baf08ed3c5/packages/crm-financial-widgets/fedops.json"} as ModuleLite,
    initHook: require('/home/builduser/work/8dadf0baf08ed3c5/packages/crm-financial-widgets/src/module').init,
    configHook: require('/home/builduser/work/8dadf0baf08ed3c5/packages/crm-financial-widgets/src/module').config,
  },
  pages: [
    
  {
    component: {"componentId":"CRM_FINANCIAL_WIDGETS.pages.index","componentType":"page","componentName":"CRM_FINANCIAL_WIDGETS.pages.index"},
    loadReactComponent: async () => (await import(/* webpackChunkName: "CRM_FINANCIAL_WIDGETS.pages.index" */ './pages/index')).default,
    
    
    
  },
  ],
  exportedComponents: [
    
  {
    component: {"componentId":"contact-invoices-tab","componentType":"exported-component"},
    loadReactComponent: async () => (await import(/* webpackChunkName: "contact-invoices-tab" */ './exported-components/ContactInvoicesTab')).default,
    
    
    
  },

  {
    component: {"componentId":"invoices-list-widget","componentType":"exported-component"},
    loadReactComponent: async () => (await import(/* webpackChunkName: "invoices-list-widget" */ './exported-components/InvoicesListWidget')).default,
    
    
    
  },

  {
    component: {"componentId":"invoices-stats-widget","componentType":"exported-component"},
    loadReactComponent: async () => (await import(/* webpackChunkName: "invoices-stats-widget" */ './exported-components/InvoicesStatsWidget')).default,
    
    
    
  },
  ],
  useEssentials: false,
  methods: [
    
  ],
  optionalDeps: {
    
    loadOptionalFlowAPIDeps: async () => (await import(/* webpackChunkName: "flowAPIDeps" */ '../flowAPIDeps')).default,
    asyncMessagesLoader: (locale: string) => import(`/home/builduser/work/8dadf0baf08ed3c5/packages/crm-financial-widgets/src/assets/locale/messages_${locale}.json`),
    createBILogger,
  },
});